import envSchema from './schema';

declare global {
  interface Window {
    ENV?: Record<string, string>;
  }
}

const parsedEnv = envSchema.parse(window.ENV || import.meta.env);

export default parsedEnv;
export type { Env } from './schema';
export { parsedEnv as env };
